import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import AddItemButton from '../../AddItemButton';


const AddItemPicker = () => {
  const { pageContentResource } = usePageContentContext();
  const { loadRightSidebarCollectionLink } = useRightSidebarContext();
  const { loadModalCollectionByLink } = useModalContext();


  return pickFunction(pageContentResource, {
    [fr.relationships.addItem.name]: () => {
      const rel = pageContentResource.relationship(fr.relationships.addItem.name);

      const link = rel.link('related');
      let loadFn = () => loadRightSidebarCollectionLink(link);
      if (rel.meta('relationshipType') === 'linkModal') {
        loadFn = () => {
          loadModalCollectionByLink(link.url());
        };
      }

      return (
        <AddItemButton
          onClick={() => {
            return loadFn();
          }}
          label={rel.meta('prompt')}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AddItemPicker;
